import __NS_DYNAMIC_REACT_CONTENT___0 from "./unauthed-footer.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { createElement, Fragment } from 'react';
import { Bold, Disclosure } from 'legos/typography';
import { isAndroid, isIOS, isWeb } from 'packages/platform-detector';
import { CurrentYear } from 'apps/acp/packages/date';
import { createUnAuthedGetBrandingRequest } from 'apps/acp/packages/webapi';
import { useHttpQuery } from 'packages/http-client/react';
import { showMobileAppsSection } from 'apps/acp/packages/mobile-apps-section-detector';
import { limitedUseAccessToken } from 'apps/acp/packages/limited-use-access-token';
import { AdaChatButton } from 'apps/acp/packages/ada-chatbot';
import { TalkdeskChatButton } from 'apps/acp/packages/talkdesk-chatbot';
import { DisclosureWrap } from './styles/paypal-unauthed-footer.ccm.css';
export const createWebapiFeatureRequest = features => ({
  method: 'POST',
  url: '/v2/features',
  body: JSON.stringify({
    features
  }),
  headers: {
    'content-type': 'application/json'
  }
});
const isCordova = isAndroid() || isIOS();
const DisclosureWrapper = DisclosureWrap.as(Disclosure);
export const UnauthedFooter = ({
  mfeConfig
}) => {
  var _a;

  const {
    brand
  } = useHttpQuery(limitedUseAccessToken(createUnAuthedGetBrandingRequest()));
  const showFDICDisclosure = ['netspend_unauthenticated_default'].includes(brand.id);
  const {
    'webapi:talkdesk_chatbot_feature_enabled': isTalkdeskEnabled
  } = (_a = useHttpQuery(createWebapiFeatureRequest(['webapi:talkdesk_chatbot_feature_enabled']))) === null || _a === void 0 ? void 0 : _a.features;
  return createElement(Fragment, null, mfeConfig.showLoginTermsAndConditionsDisclosure && createElement(Disclosure, null, mfeConfig.showChangedTermsDepositPrivacyDisclosure && createElement(Content, {
    hash: "0c98fcc6e2ba679d4a4623cec90ca9c3",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }), !mfeConfig.showChangedTermsDepositPrivacyDisclosure && createElement(Content, {
    hash: "6f56352298d68807e79a89f042cf2939",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Disclosure, null, "The Netspend\xAE Visa\xAE Prepaid Card is issued by Pathward\xAE, National Association and Republic Bank & Trust Company; Members FDIC, pursuant to a license from Visa U.S.A. Inc. The Netspend\xAE Prepaid Mastercard\xAE is issued by Pathward, N.A., and Republic Bank & Trust Company; Members FDIC, pursuant to license by Mastercard International Incorporated. The Netspend\xAE Debit Account is a deposit account established by Pathward\xAE, National Association, or Republic Bank & Trust Company; Member FDIC. Please see the back of your Card for its issuing bank. Ouro Global, Inc. is a service provider to Pathward, N.A. and Republic Bank & Trust Company. The Netspend Visa\xAE Prepaid Card can be used everywhere Visa debit cards are accepted. The Netspend Prepaid Mastercard\xAE can be used everywhere Debit Mastercard is accepted."), showFDICDisclosure && createElement(Disclosure, null, createElement(Content, {
    hash: "e000b409b8b9a96cbb0c06e7b580e200",
    devVariables: {},
    componentsAndExpressions: [(...children) => createElement("a", {
      href: "https://www.pathward.com/programbanks",
      target: "_blank"
    }, children)],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Disclosure, null, "Mastercard and the circles design are registered trademarks of Mastercard International Incorporated."), mfeConfig.showShortAppleDisclosure && createElement(DisclosureWrapper, null, createElement(Content, {
    hash: "082e910291780012812046100071769f",
    devVariables: {},
    componentsAndExpressions: [(...children) => createElement("sup", null, children), (...children) => createElement("sup", null, children)],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), !mfeConfig.showShortAppleDisclosure && !showMobileAppsSection(mfeConfig.programType || '', brand.ios_app_url) && createElement(DisclosureWrapper, null, createElement(Content, {
    hash: "d3d77b7311b70a1fad8352a964cf0f96",
    devVariables: {},
    componentsAndExpressions: [(...children) => createElement("sup", null, children), (...children) => createElement("sup", null, children)],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), !showMobileAppsSection(mfeConfig.programType || '', brand.android_app_url) && createElement(DisclosureWrapper, null, createElement(Content, {
    hash: "f94a19b9c187cc7db5a45467196c85f3",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), (!showMobileAppsSection(mfeConfig.programType || '', brand.android_app_url) || !showMobileAppsSection(mfeConfig.programType || '', brand.ios_app_url)) && createElement(Disclosure, null, createElement(Content, {
    hash: "4546e0d8c65979902aafd92a4395c291",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Disclosure, null, "*Wireless data rates may apply."), createElement(Disclosure, null, "\xA9 ", createElement(CurrentYear, null), " Ouro Global, Inc."), isCordova && createElement(Disclosure, {
    onClick: () => {
      var _a, _b;

      return ((_a = mfeConfig) === null || _a === void 0 ? void 0 : _a.mobileAppVersionOnClick) && ((_b = mfeConfig) === null || _b === void 0 ? void 0 : _b.mobileAppVersionOnClick(true));
    },
    style: {
      textAlign: 'center'
    }
  }, createElement(Content, {
    hash: "700f5804b3fe5dff78b8b404e08cc00b",
    devVariables: {
      mfeConfig: mfeConfig
    },
    componentsAndExpressions: [(...children) => createElement(Bold, null, children)],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), isTalkdeskEnabled ? createElement(TalkdeskChatButton, null) : isWeb() && createElement(AdaChatButton, null));
};